import InsightCard from './cards/InsightCard';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { useLocalization } from '../custom-hooks/useLocalization';
import { withLocalization } from '../shared/Context/LocalizationContext';
import NoResultsCard from '../shared/NoResultsCard';
import { compose } from '../utils/compose';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';

const FeaturedInsightComponent = (props) => {
  const cardProps = props.properties;
  const cardInfo = props.items[0];
  const { resourceStrings } = useLocalization();
  const noResultsMessage = resourceStrings.insightSectionWidgetNoResults;

  if (!props.items.length) {
    return (
      <WidgetIdWrapper widgetID={cardProps.widgetID}>
        <NoResultsCard noResultsMessage={noResultsMessage} />
      </WidgetIdWrapper>
    );
  }

  cardInfo.readMoreText = resourceStrings.featuredInsightLinkText;
  return (
    <WidgetIdWrapper widgetID={cardProps.widgetID}>
      <InsightCard cardProps={cardProps} item={cardInfo} />
    </WidgetIdWrapper>
  );
};

export default compose(withLocalization, withWidgetSpacingWrapper)(FeaturedInsightComponent);
